const projects = [
    {
        id: 1,
        title: 'CSN Jamshedpur Facade Work',
        location: 'Jamshedpur',
        status: 'Completed',
        workType: 'facade Glazing',
        excerpt: 'Glazing system with powder-coated aluminium frames in Champagne colour and an approved shade.',
        images: ['/projects/1/1.jpeg', '/projects/1/2.jpg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Providing & Fixing of Glazing System with Powder-Coated Aluminium Frame in Champagne Colour and Approved Shade.',
            },
            {
                title: 'Work Highlights',
                items: [
                    'Aluminium Glazing System',
                    'Powder-Coated Aluminium Frames',
                    'Champagne Colour Finish',
                    'Approved Shade',
                    'Professional facade Glazing Installation',
                    'Precision Installation & Premium Finishing',
                    'Complete Project Execution',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'High-quality materials with precision installation, clean alignment, durable powder-coated finish and premium facade finishing.',
            },
            {
                title: 'Project Description',
                text: 'A premium facade glazing project featuring a high-quality aluminium glazing system with powder-coated aluminium frames in Champagne Colour and an approved shade. The work was executed with a focus on modern aesthetics, precise installation, durability, clean finishing, and architectural appeal.',
            },
            {
                title: 'Key Highlights',
                tags: [
                    'facade Glazing',
                    'Aluminium Glazing System',
                    'Powder-Coated Aluminium Frames',
                    'Champagne Colour Finish',
                    'Premium Finishing',
                    'Completed Project',
                ],
            },
        ],
    },
    {
        id: 2,
        title: 'Navrang Square Mall',
        location: 'Ghaziabad',
        status: 'Ongoing',
        workType: 'Facade, ACP & Civil Works',
        excerpt: 'Facade glazing, glass doors and windows, spider glazing, skylight, ACP cladding and civil works.',
        images: ['/projects/2/2.jpeg', '/projects/2/1.jpeg'],
        sections: [
            {
                title: 'Facade & Glazing Work',
                items: [
                    'Fixed Windows',
                    'Spider Glazing',
                    'Atrium Space MS Frame',
                    'Skylight',
                    'Frameless Glass Doors',
                ],
            },
            {
                title: 'ACP Work',
                items: [
                    'ACP Cladding with Framing',
                    'ACP Cladding without Framing',
                ],
            },
            {
                title: 'Civil Work',
                items: ['Civil Work'],
            },
            {
                title: 'Scope of Work',
                text: 'Supply & Installation of Facade Glazing, Glass Doors & Windows, Spider Glazing, Skylight Systems, Atrium MS Structural Frame, ACP Cladding and Associated Civil Works.',
            },
            {
                title: 'Work Highlights',
                items: [
                    'Complete Facade Glazing',
                    'Glass Doors & Windows',
                    'Spider Glazing System',
                    'Skylight Work',
                    'Frameless Glass Doors',
                    'MS Atrium Structure',
                    'ACP Cladding',
                    'Civil Works',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'Quality materials, accurate fabrication and professional installation with emphasis on structural reliability, clean detailing and premium architectural finishing.',
            },
        ],
    },
    {
        id: 3,
        title: 'ATS Destinaire',
        location: 'Bisrakh, Noida / Greater Noida',
        status: 'Completed',
        workType: 'SS 304 & ACP Cladding',
        excerpt: 'SS 304 hairline sheet cladding and 4mm ACP sheet cladding.',
        images: ['/projects/3/1.jpeg', '/projects/3/2.jpeg'],
        sections: [
            {
                title: 'SS Sheet Cladding Work',
                text: 'Supply, Fabrication & Fixing of SS Sheet Cladding of Grade 304 with Hairline Finish.',
                items: [
                    'SS 304 Grade Sheet Cladding',
                    'Hairline Finish',
                    'Sheet Fabrication',
                    'Site Installation & Fixing',
                    'Complete Cladding Execution',
                ],
            },
            {
                title: 'ACP Work',
                text: 'Design, Supply, Fabrication & Installation of 4MM Thick ACP Sheet.',
                items: [
                    'ACP Sheet Cladding',
                    '4MM Thickness ACP',
                    'Design & Detailing',
                    'Fabrication',
                    'Complete Installation',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'SS 304 and ACP works executed with precise fabrication, accurate alignment, smooth finishing and durable, premium-quality surface detailing.',
            },
        ],
    },
    {
        id: 4,
        title: 'Amba Deep Building',
        location: 'Connaught Place, Delhi',
        status: 'Completed',
        workType: 'Aluminium Fixed Windows',
        excerpt: 'Aluminium fixed windows with 6mm HD blue toughened glass.',
        images: ['/projects/4/1.jpeg', '/projects/4/2.jpeg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Providing & Fixing of Aluminium Fixed Windows with 6MM HD Blue Toughened Glass.',
            },
            {
                title: 'Key Work',
                items: [
                    'Aluminium Fixed Windows',
                    '6MM HD Blue Toughened Glass',
                    'Precision Fabrication & Installation',
                    'High-Quality facade Finish',
                    'Complete Project Execution',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'High-quality aluminium and toughened glass installed with precision, ensuring clean joints, accurate alignment and a refined facade finish.',
            },
        ],
    },
    {
        id: 5,
        title: 'ATS Picture Square',
        location: 'Sector 152, Greater Noida',
        status: 'Completed',
        workType: 'Powder Coated / Anodized Aluminium',
        excerpt: '50–60 microns powder coated and anodized aluminium work.',
        images: ['/projects/5/1.jpeg', '/projects/5/2.jpeg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Providing & Fixing of 50–60 Microns Powder Coated / Anodized Aluminium Work.',
            },
            {
                title: 'Quality & Finishing',
                text: 'Premium powder-coated/anodized aluminium work with uniform finish, precise fabrication, clean installation and long-lasting surface quality.',
            },
            {
                title: 'Key Highlights',
                tags: ['Powder Coated', 'Anodized Aluminium', '50–60 Microns', 'Completed Project'],
            },
        ],
    },
    {
        id: 6,
        title: 'T&T Ghaziabad MS Work',
        location: 'Ghaziabad',
        status: 'Ongoing',
        workType: 'MS Staircase Railing',
        excerpt: 'Fabrication and installation of MS staircase railing.',
        images: ['/projects/6/2.jpeg', '/projects/6/1.jpeg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Providing & Fixing of MS Staircase Railing.',
            },
            {
                title: 'Quality & Finishing',
                text: 'MS staircase railing fabricated and installed with strong welding, accurate alignment, smooth surface preparation and durable finishing.',
            },
        ],
    },
    {
        id: 7,
        title: 'ATS Dolce',
        location: 'Greater Noida',
        status: 'Completed',
        workType: 'SS 304 Sheet Cladding',
        excerpt: 'Supply, fabrication and fixing of SS 304 sheet cladding.',
        images: ['/projects/7/1.jpg', '/projects/7/2.jpg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Supply, Fabrication & Fixing of SS Sheet Cladding of Grade 304.',
            },
            {
                title: 'Quality & Finishing',
                text: 'SS 304 cladding executed with precise fabrication, clean joints, accurate alignment and a smooth, premium finish for a refined architectural appearance.',
            },
            {
                title: 'Key Highlights',
                tags: ['SS Sheet Cladding', 'Grade SS 304', 'Completed Project'],
            },
        ],
    },
    {
        id: 8,
        title: 'Supertech ORB',
        location: 'Sector 74, Noida',
        status: 'Ongoing',
        workType: 'ACP Sheet Cladding',
        excerpt: 'Providing and fixing of 4mm thick ACP sheet cladding.',
        images: ['/projects/8/2.jpg', '/projects/8/1.jpg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Providing & Fixing of 4MM Thick ACP Sheet Cladding.',
            },
            {
                title: 'Work Highlights',
                items: [
                    'ACP Sheet Cladding',
                    '4MM Thick ACP Sheet',
                    'Precision Fabrication & Installation',
                    'Accurate Alignment & Detailing',
                    'Complete Cladding Execution',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'High-quality 4MM ACP sheets with precision fabrication and installation, ensuring accurate alignment, clean joints, durable surface finish and a modern architectural appearance.',
            },
        ],
    },
    {
        id: 9,
        title: 'Saya South X',
        location: 'Greater Noida',
        status: 'Ongoing',
        workType: 'facade Work',
        excerpt: 'Supply, fabrication, installation and handing over of facade work.',
        images: ['/projects/9/1.jpeg', '/projects/9/2.jpeg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Supply & Fabrication, Installation & Handing Over of Facade Work.',
            },
            {
                title: 'Work Highlights',
                items: [
                    'Complete facade Work',
                    'Supply & Fabrication',
                    'Professional Site Installation',
                    'Accurate Alignment & Detailing',
                    'Complete Project Execution',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'Quality materials with precision fabrication and professional installation, ensuring accurate alignment, clean detailing, durable performance and a premium architectural facade finish.',
            },
        ],
    },
    {
        id: 10,
        title: 'Spectrum Mall — Phase 1',
        location: 'Sector 75, Noida',
        status: 'Ongoing',
        workType: 'UPVC, Aluminium & Interiors',
        excerpt: 'UPVC and aluminium doors and windows, SS and MS railing, and office interior works.',
        images: ['/projects/10/1.jpeg', '/projects/10/2.jpeg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'UPVC & Aluminium Doors & Windows, SS Railing, MS Railing and Office Interior Works.',
            },
            {
                title: 'Project Overview',
                text: 'Spectrum Mall Phase 1 represents a comprehensive execution combining modern UPVC & Aluminium Doors and Windows with durable railing solutions and professional office interior work.',
            },
            {
                title: 'Our Work',
                text: 'Our scope included the supply, fabrication and installation of UPVC & Aluminium Doors & Windows, along with SS and MS Railing Works designed for strength, safety and a refined architectural appearance. The project also included office interior works, delivering a functional and professionally finished workspace.',
            },
            {
                title: 'Quality & Finishing',
                text: 'Quality materials, precision fabrication and professional installation were carried out with attention to accurate alignment, clean detailing, durability and premium finishing.',
            },
            {
                title: 'Project Highlights',
                text: 'A combination of quality materials, precision fabrication and clean installation was executed to achieve a modern, durable and visually appealing finish across the project.',
            },
        ],
    },
    {
        id: 11,
        title: 'Central Market',
        location: 'Sector 120, Noida',
        status: 'Completed',
        workType: 'facade Glazing & Glass Works',
        excerpt: 'Glass railing, facade glazing, glass doors and glass windows.',
        images: ['/projects/11/1.jpeg', '/projects/11/2.jpeg'],
        sections: [
            {
                title: 'Scope of Work',
                items: [
                    'Glass Railing Works',
                    'Installation of Glazing System – facade Work',
                    'Glass Doors',
                    'Glass Windows',
                ],
            },
            {
                title: 'Project Description',
                text: 'A comprehensive facade and glazing project featuring high-quality glass railing systems, precision-installed glazing works, and elegant glass doors and windows. The project was executed with a focus on modern aesthetics, structural reliability, precise installation, and premium finishing, creating a contemporary and visually appealing architectural facade.',
            },
            {
                title: 'Quality & Finishing',
                text: 'High-quality glass and glazing systems were installed with precision, ensuring accurate alignment, clean detailing, structural reliability and a premium architectural finish.',
            },
            {
                title: 'Key Highlights',
                tags: ['facade Glazing', 'Glass Railing', 'Glass Doors & Windows', 'Premium Finishing'],
            },
        ],
    },
    {
        id: 12,
        title: 'Passport Studios, Gaur Sons',
        location: 'Ghaziabad',
        status: 'Ongoing',
        workType: 'Elevation & Curtain Wall',
        excerpt: 'Elevation work with a curtain wall glazing system, aluminium framing and glass.',
        images: ['/projects/12/1.jpg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Elevation Work including Curtain Wall Glazing System with Aluminium Framing & Glass.',
            },
            {
                title: 'Work Highlights',
                items: [
                    'Complete Elevation Work',
                    'Curtain Wall Glazing System',
                    'Aluminium Framing & Glass',
                    'Precision Fabrication & Installation',
                    'Accurate Alignment & Detailing',
                    'Complete facade Execution',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'Quality aluminium and glass systems with precision fabrication and professional installation, ensuring accurate alignment, clean detailing, durability and a premium architectural facade finish.',
            },
        ],
    },
    {
        id: 13,
        title: 'Paras Estate',
        location: 'Meerut',
        status: 'Ongoing',
        workType: 'Georgian Bar, Elevation & facade',
        excerpt: 'Elevation and facade works with Georgian bar detailing and aluminium glazing.',
        images: ['/projects/13/1.jpg'],
        sections: [
            {
                title: 'Scope of Work',
                text: 'Elevation & facade Works including Georgian Bar detailing and installation with aluminium glazing systems.',
            },
            {
                title: 'Work Highlights',
                items: [
                    'Georgian Bar Work',
                    'Elevation Work',
                    'facade Work',
                    'Aluminium Glazing System',
                    'Precision Fabrication & Installation',
                    'Accurate Alignment & Detailing',
                    'Complete facade Execution',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'Quality materials with precise fabrication and professional installation, ensuring clean Georgian Bar detailing, accurate alignment, durable performance and a premium architectural finish.',
            },
        ],
    },
    {
        id: 14,
        title: 'Saya Marketing Office',
        location: 'Raj Nagar Extension, Ghaziabad',
        status: 'Ongoing',
        workType: 'Elevation, Glazing & Interior',
        excerpt: 'ACP front elevation, aluminium glazing and professional interior work.',
        images: ['/projects/14/1.jpg'],
        sections: [
            {
                title: 'Scope of Work',
                items: [
                    'ACP Front Elevation Work',
                    'Aluminium Glazing Work',
                    'Front Elevation Development',
                    'Interior Work',
                ],
            },
            {
                title: 'Quality & Finishing',
                text: 'Premium-quality materials with precise fabrication, clean installation, and a refined finish to achieve a modern and professional appearance.',
            },
            {
                title: 'Project Description',
                text: 'A contemporary commercial project featuring ACP and glazing work for the front elevation, complemented by professionally executed interior work to create a modern and cohesive workspace.',
            },
            {
                title: 'Key Highlights',
                tags: ['Modern Elevation', 'ACP Cladding', 'Premium Glazing', 'Professional Interior Finish'],
            },
        ],
    },
];

export default projects;
